Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div class="ui visible message"><p>' +
((__t = ( ctx.t(ctx.component.title) )) == null ? '' : __t) +
'</p></div>\n';
return __p
}